export default [
    {
        path: "pending",
        name: "SupplierPending",
        component: () =>
            import(
                /* webpackChunkName: "pending" */ "@/views/supplierPanel/sendReports/tabs/Pending.vue"
            )
    },

    {
        path: "paid",
        name: "SupplierPaid",
        component: () =>
            import(
                /* webpackChunkName: "paid" */ "@/views/supplierPanel/sendReports/tabs/Paid.vue"
            )
    }
];
